import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import styled from "styled-components";
import hero from "../Image/hero.svg";
import Signin from "./Signin_button";
import { Row, Col } from "react-bootstrap";
import "../CSS/signing.css";

function Sign() {
  return (
    <Container>
      <StyledNav>
        <NavItem>
          <NavLink href="/">
            <Logo>SocioConnect</Logo>
          </NavLink>
        </NavItem>
      </StyledNav>
      <Content>
        <Row>
          <Col xs={12} md={6}>
            <WelcomeText>
              Welcome to my <br /> Social Media App
            </WelcomeText>
            <ButtonWrapper>
              <Signin />
            </ButtonWrapper>
          </Col>
          <Col xs={12} md={6}>
            <ImageWrapper>
              <img src={hero} alt="Hero" />
            </ImageWrapper>
          </Col>
        </Row>
      </Content>
    </Container>
  );
}

export default Sign;

const Container = styled.div`
  height: 100vh;
  padding: 50px;
  overflow-y: hidden;
  background-color: #f4f8fb;
  border-radius: 15px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  @media (max-width: 700px) {
    padding: 20px;
  }
`;

const StyledNav = styled(Nav)`
  margin-bottom: 30px;
`;

const Logo = styled.h3`
  color: #2e9bd9;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
`;

const Content = styled.div`
  margin-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const WelcomeText = styled.p`
  color: #8f5849;
  font-size: 2rem;
  font-weight: 400;
  text-align: left;
  line-height: 1.4;
  @media (max-width: 700px) {
    font-size: 1.5rem;
    text-align: center;
  }
`;

const ButtonWrapper = styled.div`
  padding-top: 35px;
  padding-bottom: 35px;
  text-align: center;
`;

const ImageWrapper = styled.div`
  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);
  }
`;
